module.exports = __webpack_public_path__ + "static/media/nsb-blue-logo 1.c1daf8af.png";